<template>
    <div class="callout" style="margin: 0;">
        <div class="row">
            <div class="col-md-3">
                <input type="text" class="form-control form-control-sm" placeholder="Expediente" v-model="filtroExpediente">
            </div>
            <div class="col-md-7">
                <Dropdown optionValue="id" scrollHeight="400px" showClear v-model="tiposeleccionado" :options="tipos" filter
                    optionLabel="nombre" style="height:31px;width:150px" placeholder="Tipo">
                </Dropdown>
                <MultiSelect optionValue="id" scrollHeight="400px" showClear v-model="companiaseleccionada"
                    :options="companias" filter optionLabel="nombre" class="selector-filtro ml-2" placeholder="Compañías">
                    <template #option="slotProps">
                        <div class="flex align-items-center">
                            <div v-if="slotProps.option.nombre.length<=50">{{ slotProps.option.nombre }}<span
                                    v-if="slotProps.option.prefijo">&nbsp;({{ slotProps.option.prefijo }})</span></div>
                            <div v-else>{{ slotProps.option.nombre.slice(0, 47) }}...<span
                                    v-if="slotProps.option.prefijo">&nbsp;({{ slotProps.option.prefijo }})</span></div>

                        </div>
                    </template>
                </MultiSelect>
                <MultiSelect optionValue="id" scrollHeight="400px" showClear v-model="operarioseleccionado"
                    :options="operarios" filter optionLabel="nombre" class="selector-filtro ml-2" placeholder="Operarios">
                </MultiSelect>
                <MultiSelect scrollHeight="600px" v-model="estadoseleccionado" optionLabel="nombre" :options="estados"
                    optionGroupChildren="items" optionGroupLabel="label" optionValue="id_estado" class="selector-filtro ml-2"
                    placeholder="Pendiente de">
                </MultiSelect>
                <MultiSelect optionValue="id" scrollHeight="400px" showClear v-model="especialidadseleccionada"
                    :options="especialidades" filter optionLabel="nombre" class="selector-filtro ml-2" placeholder="Especialidades">
                </MultiSelect>
                <MultiSelect optionValue="id" scrollHeight="400px" showClear v-model="usuarioseleccionado"
                    :options="usuarios" filter optionLabel="nombre" class="selector-filtro ml-2" placeholder="Usuarios">
                </MultiSelect>
            </div>
            <div class="col-md-2 d-flex justify-content-end">
                <button class="btn btn-primary btn-sm" @click="obtenerExpedientes(mievento)">Buscar</button>
                <Button icon="fas fa-file-excel" class="btn btn-secondary btn-sm ml-2" label="Exportar"
                    @click="montarcsv(mievento)" />
            </div>
        </div>
    </div>
    <div class="callout" :style="difuminado">
        <tabla-datos :trabajos="true" :botones="true" :columnas="columnas" :datos="expedientes" :filtros="false"
            @marcar="marcar" @revisarSeleccionados="revisarSeleccionados" @desmarcar="desmarcar" :total="total"
            @obtenerExp="obtenerExpedientes($event)" @marcarTodos="marcarTodos" @desmarcarTodos="desmarcarTodos"
            @quieroDatos="obtenerExpedientes($event); mievento=$event" @page="onPage($event)" :page="pageselec"
            :num="numdatos" :servicios="true" v-if="mostrar">
        </tabla-datos>
    </div>
    <Dialog modal dismissableMask="true" :header="cabecera" :style="{ width: '50rem' }"
        :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" v-model:visible="visible">
        <p v-html="decode_utf8(mensaje)"></p>
    </Dialog>
</template>
<script>
import MultiSelect from 'primevue/multiselect';
import { PwgsApi } from '../../../services/PwgsApi';
import TablaDatos from '../../TablaDatos.vue';
import jsonToCsvExport from "json-to-csv-export";

import Dialog from 'primevue/dialog';
export default {
    components:{     
        MultiSelect,
        "tabla-datos": TablaDatos,
        Dialog,
    },
    data() {
        return {
            tiposeleccionado:'',
            tipos:[],
            marcados:[],
            difuminado:'',
            especialidades:[],
            especialidadseleccionada:'',
            mievento:[],
            mostrar:false,
            usuarioseleccionado:'',
            companiaseleccionada:'',
            filtroExpediente: '',
            estados:[],
            estadoseleccionado:[],
                pageselec:1,
                numDatos:15,
                companias:[],
            usuarios:[],
            visible:false,
            operarios:[],
            operarioseleccionado:'',
               total: '',
               expedientes: [],
               parametros: '',
               cabecera:'',
               mensaje:'',
               columnas: [
                   {
                       header: 'Tipo',
                       field: 'class',
                   },
                
                   {
                       header: 'Expediente',
                       field: 'codigo_servicio',
                       sortable: false,
                       acciones: [
                           {
                               link: true,
                               tipo: 'default',
                               nombreId: 'id_servicio',
                               nombreIddos: 'codigo_servicio',
                               // Debe ser arrow function para que this sea este componente
                               accion: (id, codigo) => {
                                   localStorage.setItem('nombreservicio' + id, codigo);
                                   localStorage.setItem('pestanyactivaservicio' + id, 'notas');

                                   this.$router.push({
                                       name: 'Servicio',
                                       params: {
                                           id: id,
                                           nombreservicio: codigo,
                                       }
                                   });
                               }
                           },
                       ]
                   },
                   {
                       header: 'Compañia',
                       field: 'nombre_compania',
                   },
                   {
                       header: 'Fecha/Hora',
                       field: 'fecha_hora',
                       sortable: true,
                   },
                   {
                       header: 'Operario',
                       field: 'nombre_operario',
                   },
                   {
                       header: 'Estado Pendiente',
                       field: 'nombre_especialidad_pendiente',
                   },
                   {
                       header: 'Especialidad',
                       field: 'nombre_especialidad',
                   },

                   {
                       header: 'Tramitador',
                       field: 'nombre_tramitador',
                       sortable: false,
                   },
                    {
                        header: '',
                        checkbox: 'checkbox',
                    },
                   {
                       data: null,
                       header: "Notas",
                       acciones: [
                           {
                               nombre: 'Nota',
                               class: 'nota',
                               tipo: 'default',
                               nombreId: 'texto_nota',
                               nombreIddos: 'codigo_servicio',

                               icono: 'far fa-clipboard',
                               // Debe ser arrow function para que this sea este componente
                               accion: (texto_nota,codigo_servicio) => {
                                   this.mensaje = texto_nota;
                                   this.cabecera = codigo_servicio;
                                   this.visible = true;
                                                                  }
                           },
                        
                       ]
                   },
                   {
                       data: null,
                       acciones: [
                           
                           {
                               nombre: 'Eliminar',
                               class: 'eliminar',
                               tipo: 'danger',
                               nombreId: 'id_aviso',
                               nombreIddos: 'codigo_servicio',

                               icono: 'far fa-trash-alt',
                               // Debe ser arrow function para que this sea este componente
                               accion: (id, codigo_servicio) => {
                                   if (confirm('Desea revisar el trabajo ' + codigo_servicio)) {

                                       this.revisarTrabajo(id);
                                   }
                               }
                           },
                       ]
                   }
               ]
           }
       },
    methods: {
        decode_utf8(s) {
            try {
                return decodeURIComponent(escape(s));
            }
            catch (error) {
                console.log(error);
                return s;
            }
        },        
        async revisarSeleccionados(){
            try{
                const api = new PwgsApi();
                await api.put('avisos/revisar-avisos', {tipo:'trabajos_no_revisados', ids_avisos:this.marcados, estado:'1'});
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Trabajos revisados correctamente', life: 2000 });
                this.obtenerExpedientes(this.mievento);
            }catch (e) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        marcar(datos){
            this.marcados.push(datos.id_aviso);
        },
        desmarcar(datos){
            const index = this.marcados.indexOf(datos.id_aviso);
            if(index > -1){
                this.marcados.splice(index, 1);
            }
        },
        async revisarTrabajo(id){
            try{
                const api = new PwgsApi();
                await api.put('avisos/revisar-avisos', {tipo:'trabajos_no_revisados', ids_avisos:[id], estado:'1'});
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Trabajo revisado correctamente', life: 2000 });
                this.obtenerExpedientes(this.mievento);
            }catch (e) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        async cargarEspecialidades() {
            const api = new PwgsApi();
            const datos = await api.get('especialidades');
            this.especialidades = datos.datos;
        },
        async cargarEstados() {
            const api = new PwgsApi();
            const resp2 = await api.get('tipos-estado-pendiente');
            this.estados = [
            {
                label:'Estados pendientes',
                items:resp2.datos.estados_pendientes
            },
            {
                label:'Especialidades',
                items:resp2.datos.especialidades
            }]
           }, 
        async eliminartrabajo(id_aviso) {
            //put pwgsapi/index.php/avisos/revisar-avisos
           const api = new PwgsApi();
           let ids = [];
           ids.push(id_aviso);
            let subidadatos = {tipo:'trabajos_no_revisados',ids_avisos:ids,estado:1,}
           await api.put('avisos/revisar-avisos', subidadatos);
        },
        async cargarCompanias() {
            const api = new PwgsApi();
            const datos = await api.get('companias/simple?sortField=nombre&sortOrder=1');
            this.companias = datos.datos;
        },
        async cargarOperarios() {
            const api = new PwgsApi();
            const datos = await api.get('operarios/simple');
            this.operarios = datos.datos;
        },
        async cargarTipos() {
            const api = new PwgsApi();
            const datos = await api.get('tipos-notas');
            for(let element of  Object.entries(datos)){
                var tipo = {
                    id: element[0],
                    nombre: element[1]
                }
                this.tipos.push(tipo);
            }
        },
        async cargarUsuarios() {
            const api = new PwgsApi();
            const datos = await api.get('usuarios/gestion,simple');
            this.usuarios = datos.datos;
        },
            onPage(evnt){
                localStorage.setItem("pageselectnr", evnt.page);
                localStorage.setItem("numdatstnr", evnt.rows);
            },
            marcarTodos(){
                this.marcados = [];
                this.expedientes.forEach(item => {
                    item.marcado = true;
                    this.marcados.push(item.id_aviso);
                });
            },
            desmarcarTodos(){
                this.marcados = [];
                this.expedientes.forEach(item => {
                    item.marcado = false;
                });
            },
            async montarcsv(event) {
                event.page = 1;
                event.first = 0;
                event.rows = 5000; 
                if(this.especialidadseleccionada){
                    event.ids_especialidades = this.especialidadseleccionada;
                }
                if(this.estadoseleccionado){
                    event.ids_esp_pend = this.estadoseleccionado;
                }
                if(this.operarioseleccionado){
                    event.ids_operarios = this.operarioseleccionado;
                }
                if(this.tiposeleccionado){
                    event.tipo = this.tiposeleccionado;
                }
                if (this.companiaseleccionada) {
                event.ids_companias = this.companiaseleccionada;
                }
                if (this.usuarioseleccionado) {
                event.ids_usuarios = this.usuarioseleccionado;
                }
                if(this.filtroExpediente !=''){
                    event.buscador = this.filtroExpediente;
                }else{
                    delete event.buscador;
                }
                const api = new PwgsApi;
                try{
                   const aux = await api.post('avisos/trabajos-no-revisados',event);
                    let fechahoy = '_F' + new Date().toLocaleDateString().replaceAll('/', '-') + '_T' + new Date().toLocaleTimeString().replaceAll(':', '-');
                    jsonToCsvExport({ data: aux.datos, filename: "TrabajosNoRevisados_" + fechahoy, delimiter: ";" });
                }catch (e) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
                }

            },
           async obtenerExpedientes(event) {
            this.marcados = [];
                this.difuminado = "filter:blur(4px);margin-top:15px;padding:0px;";
                if(this.especialidadseleccionada){
                    event.ids_especialidades = this.especialidadseleccionada;
                }
                if(this.estadoseleccionado){
                    event.ids_esp_pend = this.estadoseleccionado;
                }
                if(this.operarioseleccionado){
                    event.ids_operarios = this.operarioseleccionado;
                }
                if(this.tiposeleccionado){
                    event.tipo = this.tiposeleccionado;
                }
                if (this.companiaseleccionada) {
                event.ids_companias = this.companiaseleccionada;
                }
                if (this.usuarioseleccionado) {
                event.ids_usuarios = this.usuarioseleccionado;
                }
                if(this.filtroExpediente !=''){
                    event.buscador = this.filtroExpediente;
                }else{
                    delete event.buscador;
                }
               const api = new PwgsApi;
               try{
                   const aux = await api.post('avisos/trabajos-no-revisados',event);
                   if(aux.datos.length == 0 && this.mievento.first != 0){
                       this.mievento.first = 0;
                       this.obtenerExpedientes(this.mievento);
                   }
                   this.expedientes = aux.datos.map(function (x) {
                    x.marcado = false;
                    return x;
                   });
                   this.total = aux.n_total_registros;
                   this.$emit('evento_total_trabajos_no_revisados', this.total); //Es llamado por ./Escritorio.vue
                   this.difuminado = 'margin-top:15px;padding:0px;';
                    setTimeout(() => {
                        let columnaspar = document.getElementsByClassName("p-row-even");
                        let columnasimpar = document.getElementsByClassName("p-row-odd");
                        for(let i=0;i<columnaspar.length;i++){
                            if(columnaspar[i].innerHTML.includes('class="eliminado"') || columnaspar[i].innerHTML.includes('class="finalizado"')){
                                columnaspar[i].style.backgroundColor = '#f89393';
                            }
                        }
                        for(let i=0;i<columnasimpar.length;i++){
                            if(columnasimpar[i].innerHTML.includes('class="eliminado"') || columnasimpar[i].innerHTML.includes('class="finalizado"')){
                                columnasimpar[i].style.backgroundColor = '#f89393';
                            }
                        }

                    }, 500);
               }catch(e) {
                    this.difuminado = 'margin-top:15px;padding:0px;';
                    console.error("error",e);
                    this.expedientes = [];
                    this.total = 0;
                }
           },
           toggle(event) {
               this.$refs.op.toggle(event);
           }
       },
       activated() {
           this.obtenerExpedientes(this.mievento);
       },
           mounted() {
            this.cargarCompanias();
            this.cargarUsuarios();
            this.cargarOperarios();
            this.cargarEspecialidades();
            this.cargarEstados();
            this.cargarTipos();
            this.pageselec = parseInt(localStorage.getItem('pageselectnr'));
            this.numdatos = parseInt(localStorage.getItem('numdatstnr'));
            this.mostrar = true;
           //this.obtenerExpedientes();
       },
        watch:{
            estadoseleccionado(){
                this.pageselec = 1;
                this.mievento["first"]=0;
                if (!this.estadoseleccionado) {
                    delete this.mievento["ids_esp_pend"];
                }
            },
            especialidadseleccionada(){
                this.pageselec = 1;
                this.mievento["first"]=0;
                if (!this.especialidadseleccionada) {
                    delete this.mievento["ids_especialidades"];
                }
            },
            operarioseleccionado(){
                this.pageselec = 1;
                this.mievento["first"]=0;
                if (!this.operarioseleccionado) {
                    delete this.mievento["ids_operarios"];
                }
            },
            usuarioseleccionado(){
                this.pageselec = 1;
                this.mievento["first"]=0;
                if (!this.usuarioseleccionado) {
                    delete this.mievento["ids_usuarios"];
                }
            },
            companiaseleccionada(){
                this.pageselec = 1;
                this.mievento["first"]=0;
                if (!this.companiaseleccionada) {
                    delete this.mievento["ids_companias"];
                }
            },
            filtroExpediente(){
                this.pageselec = 1;
                this.mievento["first"]=0;
            },
            tiposeleccionado(){
            this.pageselec = 1;
            this.mievento["first"]=0;
            if (!this.tiposeleccionado) {
                delete this.mievento["tipo"];
            }
        }
        }
   }
   </script>
   <style>
   .p-dialog {
       width: 90%;
   }
   .p-datatable-header{
   
       visibility:hidden;
   }
   </style>